<template>
    <div class="view view-challenge-flow">
        <HeaderChallengeFlow />
        <div class="wr-flow-items">
            <ChallengeFlowItem
                :number="1"
                text="Başka kullanıcılara bir pratik modunda karşılaşmak üzere istek gönderebilirsin."/>

            <ChallengeFlowItem
                :number="2"
                text="İsteğin hemen ardından meydan okumayı başlatan olarak pratik oturumuna alınırsın." />

            <ChallengeFlowItem
                :number="3"
                text="Diğer kullanıcı isteğini kabul ettiğinde aynı sorularla aynı pratik oturumuna girer." />

            <ChallengeFlowItem
                :number="4"
                text="İki taraf da pratiğini tamamladığında en yüksek doğruluğa ulaşan kazanır." />
        </div>
        <BtnChallengeFlowOk
            @click="routeChallenge" />
        <BtnChallenge
            @click="routeChallenge" />
        <BtnPracticeModes
            @click="routePracticeModes" />
        <Navbar />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderChallengeFlow  from '@/components/HeaderChallengeFlow.vue';
    import ChallengeFlowItem    from '@/components/ChallengeFlowItem.vue';
    import BtnChallengeFlowOk   from '@/components/BtnChallengeFlowOk.vue';
    import BtnChallenge         from '@/components/BtnChallenge.vue';
    import BtnPracticeModes     from '@/components/BtnPracticeModes.vue';
    import Navbar               from '@/components/Navbar.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderChallengeFlow,
            ChallengeFlowItem,
            BtnChallengeFlowOk,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        methods: {
            routeChallenge(){
                this.$router.push('/challenge');
            },
            routePracticeModes(){
                this.$router.push('/practice-modes');
            }
        }
    };
</script>

<style scoped src="@/css/views/view-challenge-flow.css"></style>